var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "comando-chip ia-texto-corpo",
      class: _vm.classes,
      attrs: { "data-teste": "comando-chip" }
    },
    [
      _c(
        "span",
        {
          staticClass: "comando-chip__nome",
          attrs: { "data-teste": "comando-chip-nome" }
        },
        [_vm._v(_vm._s(_vm.rotulo))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }